export const siteUrl = 'https://san-elita.ru'

export const legalDocumentsUpdatedAt = '29.06.2026'

export const operatorRegistryNumber = '26-20-002493'

export const operatorRegistryBasis = 'Приказ № 186 от 07.12.2020'

export const companyRequisites = {
  fullName: 'ООО «Санаторий Элита»',
  inn: '2628048960',
  ogrn: '1072628000642',
  kpp: '262801001',
  legalAddress: '357700, Ставропольский край, г. Кисловодск, ул. Линейная, д. 8',
  actualAddress: '357700, Ставропольский край, г. Кисловодск, ул. Линейная, д. 8',
  phone: '8 (800) 201 27 25',
  email: 'info@san-elita.ru',
}

export const processedPersonalDataCategories = [
  'ФИО гостей и посетителей сайта',
  'номера телефонов',
  'адреса электронной почты',
  'данные бронирования (даты, состав гостей, номер брони)',
  'данные оплаты (при онлайн-оплате — через платёжного оператора)',
  'информация, необходимая для оказания санаторно-курортных услуг',
]

export const processingPurposes = [
  'обработка заявок на бронирование',
  'заключение и исполнение договора на оказание услуг',
  'информирование о статусе бронирования',
  'обеспечение работоспособности сайта',
  'исполнение требований законодательства РФ',
]

export const thirdPartyServices = [
  {
    name: 'Яндекс.Метрика',
    status: 'используется после согласия на cookies',
    note: 'Счётчик 81056569; clickmap, webvisor',
  },
  {
    name: 'Yandex Cloud API',
    status: 'используется для отправки заявок на бронирование',
    note: 'Персональные данные из формы бронирования передаются для обработки заявки',
  },
]

export const legalDocumentLinks = [
  { label: 'Политика обработки персональных данных', to: '/personal-data-policy' },
  { label: 'Согласие на обработку персональных данных', to: '/personal-data-consent' },
  { label: 'Политика cookies', to: '/cookie-policy' },
]
